import { OAreaActions, OpenAreaActions } from "@edp-store/actions/open-area.actions";
import { initialOpenAreaState, IOpenAreaState } from "@edp-store/state/open-area.state";

export function openAreaReducers(state = initialOpenAreaState, action: OAreaActions): IOpenAreaState {
    switch (action.type) {
        case OpenAreaActions.SetOpenAreaCampaign: {
            return {
                ...state,
                campaign: action.payload,
            };
        }
        case OpenAreaActions.SetSignature: {
            return {
                ...state,
                signature: action.payload,
            };
        }
        case OpenAreaActions.SetCodeValidation: {
            return {
                ...state,
                code: action.payload,
            };
        }
        case OpenAreaActions.SetBanks: {
            return {
                ...state,
                banks: action.payload,
            };
        }
        case OpenAreaActions.SetPaymentStatus: {
            return {
                ...state,
                paymentStatus: action.payload,
            };
        }
        case OpenAreaActions.SetPayment: {
            return {
                ...state,
                payment: action.payload,
            };
        }
        case OpenAreaActions.SetNewCode: {
            return {
                ...state,
                newCode: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
